<template>
  <v-card min-height="100vh" color="grey lighten-3">
    <BaseToolbar
      ref="base-toolbar"
      @close="closeUploadDialogLocal"
      :title="$t('recurring_debit.titles.upload_files')"
      type-title="icon"
      icon="cloud_upload"
      backgroundColor="#2661FF"
    />
    <v-card-text style="overflow-y: auto;height: calc(100vh - 64px)">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-card tile outlined>
              <v-card-text class="pa-0">
                <template v-for="(item, index) in files">
                  <v-list-item :ref="`file-list-${index}`">
                    <v-list-item-content>
                      <v-list-item-title :ref="`file-list-${index}-text`">
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        @click="removeFile(index)"
                        icon
                        ref="button-remove-file"
                      >
                        <v-icon color="grey lighten-1">
                          clear
                        </v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider/>
                </template>

                <v-list-item @click="pickFile" two-line>
                  <v-list-item-avatar>
                    <v-icon x-large color="primary">
                      add_circle_outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-if="files.length">
                      {{ $t("recurring_debit.main.add_more") }}
                    </v-list-item-title>
                    <v-list-item-title v-else>
                      {{ $t("recurring_debit.main.add_files") }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="files.length">
                      {{ files.length }}
                      {{ $t("recurring_debit.main.added_files") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <input
                  ref="inputFile"
                  @change="onFilePicked"
                  multiple
                  type="file"
                  style="display: none"
                  accept="text/*"
                />
              </v-card-text>
              <v-divider />
              <v-card-actions class="pa-4 d-flex justify-center">
                <v-btn
                  ref="button-upload"
                  :disabled="uploadButtonDisabled"
                  @click="upload"
                  color="orange darken-1"
                  rounded
                  class="white--text px-4"
                >
                  <template v-if="submitLoading">
                    <v-progress-circular indeterminate color="white" />
                  </template>
                  <template v-else>
                    {{ $t("recurring_debit.main.upload") }}
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import BaseToolbar from "@/components/BaseToolbar";

export default {
  name: "Upload",
  components: { BaseToolbar },
  data() {
    return {
      files: [],
      filesEncoding: [],
      submitLoading: false,
      validFileType: ["text/plain", "text/csv", "application/vnd.ms-excel"]
    };
  },
  computed: {
    ...mapState({
      isUploadDialogOpen: ({ recurringDebit: { isUploadDialogOpen } }) =>
        isUploadDialogOpen
    }),
    uploadButtonDisabled() {
      return this.files.length > 0 ? !!this.submitLoading : true;
    }
  },
  methods: {
    ...mapMutations({ closeUploadDialog: "recurringDebit/closeUploadDialog" }),
    ...mapActions({ uploadPlainFiles: "recurringDebit/uploadPlainFiles" }),
    async upload() {
      this.submitLoading = true;
      const res = await this.uploadPlainFiles({ upload: this.filesEncoding });
      this.$emit("meta", res);
      this.cleanData();
      this.closeUploadDialog();
    },
    closeUploadDialogLocal() {
      this.cleanData();
      this.closeUploadDialog();
    },
    cleanData() {
      this.submitLoading = false;
      this.files = [];
      this.filesEncoding = [];
    },
    pickFile() {
      this.$refs.inputFile.click();
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.filesEncoding.splice(index, 1);
    },
    onFilePicked(e) {
      const { files } = e.target;
      for (let index = 0; index < files.length; index++) {
        const fr = new FileReader();
        if (files[index] !== undefined) {
          const { type } = files[index];
          // if (this.validFileType.some(elem => elem === type)) {
          fr.readAsDataURL(files[index]);
          fr.addEventListener("load", () => {
            this.files.push(files[index]);
            this.filesEncoding.push({
              name: files[index].name.split(".")[0],
              encoding: fr.result
              // .replace('data:text/plain;base64,', '')
              // .replace('data:text/csv;base64,', '')
              // .replace('data:application/vnd.ms-excel;base64,', '')
            });
          });
          // } else {
          // 	this.$toast.global.error(this.$t('recurring_debit.messages.only_plain_files'))
          // }
        }
      }
    }
  }
};
</script>
